import { saveAs } from 'file-saver';

export async function downloadFile<TParams>(
  trigger: (params: TParams) => { unwrap: () => Promise<Blob> },
  params: TParams,
  filenameFn: (params: TParams) => string
) {
  const blob = await trigger(params).unwrap();
  const filename = filenameFn(params);
  saveAs(blob, filename);
}
